import { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import { ScanBarcode } from 'iconoir-react';

import DataTableSearchInput from '@savgroup-front-common/core/src/components/Datatable/DatatableFilters/DataTableSearchInput';
import type { MessageType } from '@savgroup-front-common/types';

import MobileBarcodeScanModal from '../MobileBarcodeScanModal';
import {
  $MobileSearchBar,
  $MobileSearchInputWrap,
  $MobileSearchRow,
  $ScanButton,
} from './MobileListSearchBar.styles';
import messages from './messages';

export interface MobileListSearchBarProps {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClear: () => void;
  onScanResult?: (code: string) => void;
  placeholder?: MessageType;
  dataTestId?: string;
  hasTopMargin?: boolean;
}

const MobileListSearchBar = ({
  value,
  onChange,
  onClear,
  onScanResult,
  placeholder,
  dataTestId = 'mobile-list-search',
  hasTopMargin = true,
}: MobileListSearchBarProps) => {
  const intl = useIntl();
  const [isScanOpen, setIsScanOpen] = useState(false);

  const handleOpenScan = useCallback(() => {
    setIsScanOpen(true);
  }, []);

  const handleCloseScan = useCallback(() => {
    setIsScanOpen(false);
  }, []);

  const handleCodeDetected = useCallback(
    (code: string) => {
      onScanResult?.(code);
    },
    [onScanResult],
  );

  return (
    <$MobileSearchBar $hasTopMargin={hasTopMargin}>
      <$MobileSearchRow>
        <$MobileSearchInputWrap>
          <DataTableSearchInput
            value={value}
            onChange={onChange}
            onClear={onClear}
            placeholder={placeholder ?? intl.formatMessage(messages.placeholder)}
            dataTestId={dataTestId}
          />
        </$MobileSearchInputWrap>
        <$ScanButton
          type="button"
          onClick={handleOpenScan}
          aria-label={intl.formatMessage(messages.scanAriaLabel)}
          data-testid={`${dataTestId}-scan-button`}
        >
          <ScanBarcode width={22} height={22} strokeWidth={1.75} />
        </$ScanButton>
      </$MobileSearchRow>
      <MobileBarcodeScanModal
        isOpen={isScanOpen}
        onClose={handleCloseScan}
        onCodeDetected={handleCodeDetected}
      />
    </$MobileSearchBar>
  );
};

export default MobileListSearchBar;
